import React, { Fragment, useState } from 'react'
import { Row, Col } from 'reactstrap'
import SocialAccountProvider from '../Multipost/socialAccountProvider'

export default function MultipostDetails({share}) {
  const filesForProvider = (provider) => share.metadata.files?.filter(file => file.accounts.includes(provider.name)) || []

  const actionsForProvider = (provider) => {
    let targets = [provider.feedName]
    if(filesForProvider(provider).some(file => file.story)){
      targets.push("Story")
    }
    return ["Post to", targets.join(" and ")].join(" ")
  }

  const assetsForProvider = (provider) => {
    return filesForProvider(provider).map(file => {
      const attributes = share.assets.find(asset => asset.id == file.id).attributes
      let previewUrl
      let width, height

      switch(file.type){
        case 'graphic':
          ({width, height} = attributes.formats.find(format => format.id == file.format))
          previewUrl = attributes.preview_urls[file.format]
          break
        case 'upload':
          ({width, height} = attributes)
          previewUrl = attributes.thumb_url
          break
      }

      return (
        <Col xs="auto" key={[provider.name, file.type, file.id, file.format].join('-')} className="ps-0 p-1">
          <div style={{aspectRatio: `${width || 1} / ${height || 1}`, height:'20px'}} className='rounded-2 overflow-hidden'>
            <img src={previewUrl}
            style={{
              objectFit: 'contain',
              height:'100%',
              width:'100%',
              verticalAlign:'unset',
            }} alt="" />
          </div>
        </Col>
      )
    })
  }

  const messageForProvider = (provider) => {
    const [expanded, setExpanded] = useState(false)
    const toggleExpand = (e) => {
      e.preventDefault()
      setExpanded(!expanded)
    }

    const messageText = share.metadata.messages[provider.name] || share.metadata.messages.default || ''

    // if text is longer than 80 chars or contains newlines, it probably overflows
    const overflows = messageText.length > 80 || messageText.includes('\n')

    return (
      <div className="rounded py-2 px-3 bg-light text-muted style-italic" style={{whiteSpace: 'pre-line'}} onClick={toggleExpand}>
        <div className={expanded ? '' : 'text-truncate'}>
          {messageText || <em>No post text entered</em>}
        </div>
        {overflows && (
          <a href="#" className="fs-6" onClick={toggleExpand}>{expanded ? 'show less' : 'show more'}</a>
        )}
      </div>
    )
  }

  return (
    <div>
      <p className="d-md-none mb-1 text-muted">
        {share.scheduled_at.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit', timeZoneName: 'short' })}
      </p>
      <div className="mt-md-n2">
        {Object.entries(share.metadata.accounts).map(([providerName, account]) => {
          const provider = SocialAccountProvider.find(providerName)
          return (
            <Fragment key={providerName}>
              <Row className="align-items-center my-1 pe-2 pe-lg-0">
                <Col xs="auto" className="pe-0">
                  {React.createElement(provider.icon, { className: "icon icon-md" })}
                </Col>
                <Col>
                  <strong>{provider.title}</strong>
                  <small className="d-block text-muted">{actionsForProvider(provider)}</small>
                </Col>
                {assetsForProvider(provider)}
              </Row>
              <Row className="ps-5">
                <Col className="ps-0">
                  {messageForProvider(provider)}
                </Col>
              </Row>
            </Fragment>
          )
        })}
        <small className="text-muted d-block mt-3 style-italic" style={{marginLeft: '36px'}}>Scheduled by {share.user.name}</small>
      </div>
    </div>
  )
}